import React, { useState, useEffect } from "react";
import uuid from "react-uuid";
import Header from "../NewHeader/NewHeader";
import "./PaymentDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";
//import PaymentDetailsSkeleton from "./PaymentDetailsSkeleton";
import moment from "moment";
import DialCode from "./DialCode";
import ReactHtmlParser from "react-html-parser";
import {
  CartConfirmBooking,
  CartConfirmBookingTesting,
  getAgentCommissionDetails,
  getAccomadationBookingIdEJuniferData,
  getGeoInfo,
  getCustomerLogin,
  CyberSource,
  cartConfirmBookingAgentZeroAmount,
} from "../axios";

//import { PDFDownloadLink } from "@react-pdf/renderer";
import { useSelector, useDispatch } from "react-redux";
import { clearToCart, updateToCart } from "../../redux/actions/actions";
import {
  constant,
  displayDateFormat,
} from "../AdminPackageDetails/PackageShowcase/commonFunction";
import LoginComponent from "../Auth/LoginComponent";
import { IS_API_ENVIRONMENT_TESTING } from "../UrlAPI";
//import InvoiceAgent from "./InvoiceAgent/Invoice";
const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

function PaymentCartDetails() {
  const dispatch = useDispatch();

  const [customerDetails, setcustomerDetails] = useState(
    localStorage.getItem("userDetails") || "abc"
  );
  const newselectedData = useSelector((state) => state.cardItems.cardData);
  const selectedData = useSelector((state) => state.cardItems.cardData);
  const {
    packageBasicDetails,
    customerPackageAfterDiscountAmount,
  } = useSelector((state) => state.adminPackageCart);

  const isPackageCart = selectedData.some((x) =>
    x.hasOwnProperty("package_id")
  );

  const [drop, toggledrop] = useState({
    class: "HotelInfo",
    formClass: "form-guest",
    buisnessFormClass: "buisnessShort",
    requestClass: "all-requests",
  });
  const [GuestCount, setGuestCount] = useState([]);

  const [Guest, setGuest] = useState([
    {
      title: "Mr",
      age: "1",
      FirstName: "",
      LastName: "",
      ErrorFirstName: false,
      ErrorLastName: false,
      mainID: "",
    },
  ]);

  const [EmailId, setEmailId] = useState();
  const [MobileNumber, setMobileNumber] = useState("");
  const [MobileCode, setMobileCode] = useState("");
  const [EmailError, setEmailError] = useState(false);
  const [MobileError, setMobileError] = useState(false);
  const [country, setcountry] = useState("");
  const [country_code, setcountry_code] = useState("");
  const [currency, setcurrency] = useState("");
  const [ip_address, setip_address] = useState("");
  const [TransactionUUID, setTransactionUUID] = useState(uuid());
  const [DisablePayNowButton, setDisablePayNowButton] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [TourDetails, setTourDetails] = useState("");
  const [TotalPrice, setTotalPrice] = useState(0);
  const [Commission, setCommission] = useState(0);
  const [CommissionAmount, setCommissionAmount] = useState(0);
  const [FinalAmount, setFinalAmount] = useState(0);
  const [StartDate, setStartDate] = useState(null);
  const [Enddate, setEnddate] = useState(null);
  const [PaylaterButton, setPaylaterButton] = useState(false);

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const onOpenLogin = () => setIsLoginOpen(true);
  const onCloseLogin = () => setIsLoginOpen(false);

  let customerArr = localStorage.getItem("userDetails");
  let CustomArr = JSON.parse(customerArr);
  let customer_id = CustomArr?.id;

  useEffect(() => {
    if (customerDetails == "abc") {
      loginPage();
    }
  }, [customerDetails]);

  useEffect(() => {
    newselectedData.length > 0 &&
      Object.entries(newselectedData).map((reducdata, c) => {
        if (reducdata[1].profileactivity == "Accommodations") {
          if (reducdata[1].junifer != null) {
            getAccomadationBookingIdEJuniferData(
              reducdata[1].hotel_id,
              reducdata[1].hotelData,
              reducdata[1].rateplancode
            ).then(
              (result) => {
                result.map((item, key) => {
                  var newDatareduxShow = {
                    tour_id: null,
                    dateselected: null,
                    tourImage: null,
                    number: null,
                    ratePlanId: null,
                    numberTraveler: null,
                    tourName: null,
                    tourOption: null,
                    tourLocation: null,
                    time: null,
                    price_type: null,
                    tour_operator_id: null,
                    profileactivity: "Accommodations",
                    overview: null,
                    hotel_id: reducdata[1].hotel_id,
                    propertyName: reducdata[1].propertyName,
                    hotelimage: reducdata[1].hotelimage,
                    startDate: reducdata[1].startDate,
                    endDate: reducdata[1].endDate,
                    guestCombination: reducdata[1].guestCombination,
                    property_source: reducdata[1].property_source,
                    rateplancode: reducdata[1].rateplancode,
                    cartvalue: reducdata[1].cartvalue,
                    hotelData: reducdata[1].hotelData,
                    roomcount: reducdata[1].roomcount,
                    adultcount: reducdata[1].adultcount,
                    childcount: reducdata[1].childcount,
                    junifer: reducdata[1].junifer,
                    price: reducdata[1].price,
                    percentageAm: reducdata[1].percentageAm,
                    percentage: reducdata[1].percentage,
                    totalAmount: reducdata[1].totalAmount,
                    taxfeeepercent: 0,
                    totalamountincluded: reducdata[1].totalamountincluded,
                    taxamount: 0,
                    bookingEjunifer: item,
                    checkin: reducdata[1].checkin,
                    checkout: reducdata[1].checkout,
                    propertydescription: reducdata[1].propertydescription,
                    propertylocation: reducdata[1].propertylocation,
                    singleamount: reducdata[1].singleamount,
                    typedata: reducdata[1].typedata,
                    roomname: reducdata[1].roomname,
                    roombooking: null,
                    accommodationtype: "ejunifer",
                    OfferName: reducdata[1].OfferName,
                    cancellationpolicy: reducdata[1].cancellationpolicy,
                    firstcancellationdate: reducdata[1].firstcancellationdate,
                    paylater: reducdata[1].paylater,
                    paylater: reducdata[1].serviceDate,
                  };

                  const CartData = newselectedData;
                  let CartItems = [...CartData];
                  CartItems.splice(c, 1);

                  CartItems.splice(c, 0, newDatareduxShow);

                  dispatch(clearToCart());

                  setTimeout(() => {
                    dispatch(updateToCart(CartItems));
                  }, 1000);
                });
              },
              (error) => {}
            );
          }
        }
      });

    getAgentCommissionDetails(customer_id).then(
      (data) => {
        if (data != "") {
          setCommission(data);
        }
      },
      (error) => {}
    );

    setTourDetails(selectedData);

    const totalprice = selectedData.reduce(
      (amount, item) => item.totalamountincluded + amount,
      0
    );
    let commissionAmount = (parseFloat(Commission) / 100) * totalprice;
    setCommissionAmount(commissionAmount);
    let FinalAmountData = totalprice - commissionAmount;
    setFinalAmount(FinalAmountData);
    setTotalPrice(totalprice);

    getGeoInfo().then(
      (data) => {
        setcountry(data.country_name);
        setcountry_code(data.country_calling_code);
        setcurrency(data.currency);
        setip_address(data.ip);
      },
      (error) => {}
    );
    let userData = localStorage.getItem("userDetails");

    if (userData != null) {
      let newData = JSON.parse(userData);
      getCustomerLogin(newData.email).then(
        (data) => {
          // console.log(data);
          setcustomerDetails(data);
          // let Verified = "";
          // if (data.verified == 1) {
          //   Verified = true;
          // }

          // const dataSearch = {
          //   first_name: data.first_name,
          //   last_name: data.last_name,
          //   email: data.email,
          //   country_code: data.country_code,
          //   verified: Verified,
          //   uid: data.id,
          // };

          // let JsonData = JSON.stringify(dataSearch);

          // localStorage.setItem("userDetails", JsonData);
          // setcustomerDetails(data);
          if (data.user == "nouser") {
            let Verified = "";
            if (data.agent.verified == 1) {
              Verified = true;
            }

            const dataSearch = {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              country_code: data.country_code,
              verified: Verified,
              uid: data.id,
            };

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem("userDetails", JsonData);
          } else {
            let Verified = true;

            const dataSearch = {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              country_code: data.country_code,
              verified: Verified,
              uid: data.id,
            };

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem("userDetails", JsonData);
          }
        },
        (error) => {}
      );
    }
    let result = [];
    selectedData.length > 0 &&
      Object.entries(selectedData).map((itemdata, j) => {
        if (itemdata[1].profileactivity != "Accommodations") {
          let numberTravelerNew = JSON.parse(itemdata[1].numberTraveler);
          setGuestCount(numberTravelerNew);
          if (itemdata[1].price_type == 1) {
            const adultCounter = numberTravelerNew.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = numberTravelerNew.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );
            const youthCounter = numberTravelerNew.reduce(
              (a, v) => a + v.youthCounter * 1,
              0
            );
            const seniorCounter = numberTravelerNew.reduce(
              (a, v) => a + v.seniorCounter * 1,
              0
            );
            const infantCounter = numberTravelerNew.reduce(
              (a, v) => a + v.infantCounter * 1,
              0
            );

            const TotalCount =
              adultCounter * 1 +
              childCounter * 1 +
              youthCounter * 1 +
              seniorCounter * 1 +
              infantCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          } else {
            const groupCounter = 1;
            for (var i = 0; i < groupCounter; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          }
        } else {
          if (itemdata[1].typedata == "multiple") {
            const GuesttravellerCount = itemdata[1].cartvalue;
            const adultCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );
            const roomcountDetails = GuesttravellerCount.reduce(
              (a, v) => a + v.roomCounter * 1,
              0
            );
            setGuestCount(GuesttravellerCount);
            const TotalCount = adultCounter * 1 + childCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          } else {
            const GuesttravellerCount = itemdata[1].guestCombination;
            const adultCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );

            const roomcountDetails = GuesttravellerCount.reduce(
              (a, v) => a + v.roomCounter * 1,
              0
            );
            setGuestCount(GuesttravellerCount);
            const TotalCount = adultCounter * 1 + childCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          }
        }
      });

    setGuest(result);
    // selectedData
    // check if "value3" is in the object
    //     console.log(selectedData[0]);
    // if (Object.values(selectedData).includes('value3')) {
    //   console.log('value3 is in the object')
    // } else {
    //   console.log('value3 is not in the object')
    // }
    const isFound = selectedData.some((element) => {
      if (element.paylater === "") {
        return true;
      }
      return false;
    });
    if (isFound) {
      // object is contained in the array
      setPaylaterButton(false);
    } else {
      setPaylaterButton(true);
    }
    //console.log(isFound);
  }, []);

  const onChangeSame = (val) => {
    const filterData = Guest.filter((x) => x.mainID == 0);

    if (val) {
      let result = [];
      selectedData.length > 0 &&
        Object.entries(selectedData).map((itemdata, j) => {
          if (itemdata[1].profileactivity != "Accommodations") {
            let numberTravelerNew = JSON.parse(itemdata[1].numberTraveler);
            setGuestCount(numberTravelerNew);
            if (itemdata[1].price_type == 1) {
              const adultCounter = numberTravelerNew.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = numberTravelerNew.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );
              const youthCounter = numberTravelerNew.reduce(
                (a, v) => a + v.youthCounter * 1,
                0
              );
              const seniorCounter = numberTravelerNew.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              );
              const infantCounter = numberTravelerNew.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              );

              const TotalCount =
                adultCounter * 1 +
                childCounter * 1 +
                youthCounter * 1 +
                seniorCounter * 1 +
                infantCounter * 1;
              for (var i = 0; i < TotalCount; i++) {
                if (filterData[i] !== undefined) {
                  if (i === filterData[i].indexid) {
                    result.push({
                      title: filterData[i].title,
                      age: filterData[i].age,
                      FirstName: filterData[i].FirstName,
                      LastName: filterData[i].LastName,
                      ErrorFirstName: false,
                      ErrorLastName: false,
                      mainID: j,
                      indexid: i,
                    });
                  }
                } else {
                  result.push({
                    title: "Mr",
                    age: "1",
                    FirstName: "",
                    LastName: "",
                    ErrorFirstName: false,
                    ErrorLastName: false,
                    mainID: j,
                    indexid: i,
                  });
                }
              }
              //GuestData = result;
            } else {
              const groupCounter = numberTravelerNew.reduce(
                (a, v) => a + v.groupCounter * 1,
                0
              );
              for (var i = 0; i < groupCounter; i++) {
                if (filterData[i] !== undefined) {
                  if (i === filterData[i].indexid) {
                    result.push({
                      title: filterData[i].title,
                      age: filterData[i].age,
                      FirstName: filterData[i].FirstName,
                      LastName: filterData[i].LastName,
                      ErrorFirstName: false,
                      ErrorLastName: false,
                      mainID: j,
                      indexid: i,
                    });
                  }
                } else {
                  result.push({
                    title: "Mr",
                    age: "1",
                    FirstName: "",
                    LastName: "",
                    ErrorFirstName: false,
                    ErrorLastName: false,
                    mainID: j,
                    indexid: i,
                  });
                }
              }
            }
          } else {
            if (itemdata[1].typedata == "multiple") {
              const GuesttravellerCount = itemdata[1].cartvalue;
              const adultCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );
              const roomcountDetails = GuesttravellerCount.reduce(
                (a, v) => a + v.roomCounter * 1,
                0
              );
              setGuestCount(GuesttravellerCount);
              const TotalCount = adultCounter * 1 + childCounter * 1;

              for (var i = 0; i < TotalCount; i++) {
                if (filterData[i] !== undefined) {
                  if (i === filterData[i].indexid) {
                    result.push({
                      title: filterData[i].title,
                      age: filterData[i].age,
                      FirstName: filterData[i].FirstName,
                      LastName: filterData[i].LastName,
                      ErrorFirstName: false,
                      ErrorLastName: false,
                      mainID: j,
                      indexid: i,
                    });
                  }
                } else {
                  result.push({
                    title: "Mr",
                    age: "1",
                    FirstName: "",
                    LastName: "",
                    ErrorFirstName: false,
                    ErrorLastName: false,
                    mainID: j,
                    indexid: i,
                  });
                }
              }
            } else {
              const GuesttravellerCount = itemdata[1].guestCombination;
              const adultCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );

              const roomcountDetails = GuesttravellerCount.reduce(
                (a, v) => a + v.roomCounter * 1,
                0
              );
              setGuestCount(GuesttravellerCount);
              const TotalCount = adultCounter * 1 + childCounter * 1;

              for (var i = 0; i < TotalCount; i++) {
                if (filterData[i] !== undefined) {
                  if (i === filterData[i].indexid) {
                    result.push({
                      title: filterData[i].title,
                      age: filterData[i].age,
                      FirstName: filterData[i].FirstName,
                      LastName: filterData[i].LastName,
                      ErrorFirstName: false,
                      ErrorLastName: false,
                      mainID: j,
                      indexid: i,
                    });
                  }
                } else {
                  result.push({
                    title: "Mr",
                    age: "1",
                    FirstName: "",
                    LastName: "",
                    ErrorFirstName: false,
                    ErrorLastName: false,
                    mainID: j,
                    indexid: i,
                  });
                }
              }
            }
          }
        });
      setGuest(result);
    } else {
      let result = [];
      selectedData.length > 0 &&
        Object.entries(selectedData).map((itemdata, j) => {
          if (itemdata[1].profileactivity != "Accommodations") {
            let numberTravelerNew = JSON.parse(itemdata[1].numberTraveler);
            setGuestCount(numberTravelerNew);
            if (itemdata[1].price_type == 1) {
              const adultCounter = numberTravelerNew.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = numberTravelerNew.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );
              const youthCounter = numberTravelerNew.reduce(
                (a, v) => a + v.youthCounter * 1,
                0
              );
              const seniorCounter = numberTravelerNew.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              );
              const infantCounter = numberTravelerNew.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              );

              const TotalCount =
                adultCounter * 1 +
                childCounter * 1 +
                youthCounter * 1 +
                seniorCounter * 1 +
                infantCounter * 1;
              for (var i = 0; i < TotalCount; i++) {
                result.push({
                  title: "Mr",
                  age: "1",
                  FirstName: "",
                  LastName: "",
                  ErrorFirstName: false,
                  ErrorLastName: false,
                  mainID: j,
                  indexid: i,
                });
              }
            } else {
              const groupCounter = numberTravelerNew.reduce(
                (a, v) => a + v.groupCounter * 1,
                0
              );
              for (var i = 0; i < groupCounter; i++) {
                result.push({
                  title: "Mr",
                  age: "1",
                  FirstName: "",
                  LastName: "",
                  ErrorFirstName: false,
                  ErrorLastName: false,
                  mainID: j,
                  indexid: i,
                });
              }
            }
          } else {
            if (itemdata[1].typedata == "multiple") {
              const GuesttravellerCount = itemdata[1].cartvalue;
              const adultCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );
              const roomcountDetails = GuesttravellerCount.reduce(
                (a, v) => a + v.roomCounter * 1,
                0
              );
              setGuestCount(GuesttravellerCount);
              const TotalCount = adultCounter * 1 + childCounter * 1;
              for (var i = 0; i < TotalCount; i++) {
                result.push({
                  title: "Mr",
                  age: "1",
                  FirstName: "",
                  LastName: "",
                  ErrorFirstName: false,
                  ErrorLastName: false,
                  mainID: j,
                  indexid: i,
                });
              }
            } else {
              const GuesttravellerCount = itemdata[1].guestCombination;
              const adultCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.adultCounter * 1,
                0
              );
              const childCounter = GuesttravellerCount.reduce(
                (a, v) => a + v.childCounter * 1,
                0
              );

              const roomcountDetails = GuesttravellerCount.reduce(
                (a, v) => a + v.roomCounter * 1,
                0
              );
              setGuestCount(GuesttravellerCount);
              const TotalCount = adultCounter * 1 + childCounter * 1;
              for (var i = 0; i < TotalCount; i++) {
                result.push({
                  title: "Mr",
                  age: "1",
                  FirstName: "",
                  LastName: "",
                  ErrorFirstName: false,
                  ErrorLastName: false,
                  mainID: j,
                  indexid: i,
                });
              }
            }
          }
        });
      setGuest(result);
    }
  };

  let OnChangeTitle = (event, index) => {
    let cats = [...Guest];
    cats[index]["title"] = event.target.value;
    setGuest(cats);
    if (isPackageCart) {
      onChangeSame(true);
    }
  };

  let OnChangeAge = (event, index) => {
    let cats = [...Guest];
    cats[index]["age"] = event.target.value;
    setGuest(cats);
    if (isPackageCart) {
      onChangeSame(true);
    }
  };

  let OnChangeFirstName = (event, index) => {
    let cats = [...Guest];

    cats[index]["FirstName"] = event.target.value;
    let firstregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
    if (event.target.value.length >= 1 && firstregMatch) {
      cats[index]["FirstNameError"] = false;
    } else {
      cats[index]["FirstNameError"] = true;
    }

    setGuest(cats);
    if (isPackageCart) {
      onChangeSame(true);
    }
  };

  let OnChangeLastName = (event, index) => {
    let cats = [...Guest];

    cats[index]["LastName"] = event.target.value;
    let lastregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
    if (event.target.value.length >= 1 && lastregMatch) {
      cats[index]["LastNameError"] = false;
    } else {
      cats[index]["LastNameError"] = true;
    }

    setGuest(cats);
    if (isPackageCart) {
      onChangeSame(true);
    }
  };

  let OnChangeEmailId = (event) => {
    const email = validEmailRegex.test(event.target.value);
    if (email == true) {
      setEmailId(event.target.value);
      setEmailError(false);
    } else {
      setEmailId(event.target.value);
      setEmailError(true);
    }
  };
  let OnChangeMobileNumber = (event) => {
    const mobile = event.target.value;
    let mobileregMatch = /^[0-9]*$/.test(event.target.value);
    if (mobile.length > 5 && mobile.length < 15 && mobileregMatch) {
      setMobileNumber(event.target.value);
      setMobileError(false);
    } else {
      setMobileNumber(event.target.value);
      setMobileError(true);
    }
  };
  let OnChangeMobileCode = (event) => {
    setMobileCode(event.target.value);
  };

  const returnInputs = () => {
    const numbers = Array.from({ length: 120 }, (_, i) => i + 1);
    const listItems = numbers.map((number) => (
      <option value={number}>{number}</option>
    ));
    return listItems;
  };

  let loginPage = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setIsLoginOpen(true);
  };

  let ConfirmBooking = (e) => {
    e.preventDefault();
    let CheckError = false;
    let CheckErrorEmail = false;
    let CheckErrorMobile = false;

    let GuestN = [...Guest];

    for (var i = 0; i < GuestN.length; i++) {
      let firstregMatch = /^[a-zA-Z ]*$/.test(GuestN[i].FirstName);
      if (GuestN[i].FirstName.length >= 1 && firstregMatch) {
        CheckError = true;
        GuestN[i]["FirstNameError"] = false;
      } else {
        CheckError = false;
        GuestN[i]["FirstNameError"] = true;
      }
      let lastregMatch = /^[a-zA-Z ]*$/.test(GuestN[i].LastName);
      if (GuestN[i].LastName.length >= 1 && lastregMatch) {
        CheckError = true;
        GuestN[i]["LastNameError"] = false;
      } else {
        CheckError = false;
        GuestN[i]["LastNameError"] = true;
      }
    }

    setGuest(GuestN);

    const email = validEmailRegex.test(EmailId);
    if (email == true) {
      setEmailError(false);
      CheckErrorEmail = true;
    } else {
      CheckErrorEmail = false;
      setEmailError(true);
    }

    let mobileregMatch = /^[0-9]*$/.test(MobileNumber);
    if (MobileNumber.length > 5 && MobileNumber.length < 15 && mobileregMatch) {
      CheckErrorMobile = true;
      setMobileError(false);
    } else {
      CheckErrorMobile = false;
      setMobileError(true);
    }

    if (
      CheckError == true &&
      CheckErrorEmail == true &&
      CheckErrorMobile == true
    ) {
      let text =
        "Please confirm your details and amount of purchase before proceeding forward.";
      if (window.confirm(text) == true) {
        // text = "You pressed OK!";

        setDisablePayNowButton(true);
        setRedirect(true);
        let customerArr = localStorage.getItem("userDetails");

        let CustomArr = JSON.parse(customerArr);

        let customer_id = CustomArr?.uid;

        const TotalPrice = selectedData.reduce(
          (amount, item) => parseFloat(item.price) + amount,
          0
        );

        const TaxandFee = 0;
        let TotalPriceInclude = TaxandFee + TotalPrice;
        let CommissionPrice = 0;
        let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
        let paylaterstatus = 0;

        // if (IS_API_ENVIRONMENT_TESTING) {
        //   CartConfirmBookingTesting(
        //     TourDetails,
        //     Guest,
        //     GuestCount,
        //     EmailId,
        //     MobileNumber,
        //     MobileCode,
        //     customer_id,
        //     FinalPrice,
        //     CommissionPrice,
        //     TransactionUUID,
        //     StartDate,
        //     Enddate,
        //     paylaterstatus
        //   ).then(
        //     (data) => {
        //       const url = "/PlanTrips";
        //       window.location.replace(url);
        //       dispatch(clearToCart());
        //     },
        //     (error) => {}
        //   );
        // } else {
        CartConfirmBooking(
          TourDetails,
          Guest,
          GuestCount,
          EmailId,
          MobileNumber,
          MobileCode,
          customer_id,
          FinalPrice,
          CommissionPrice,
          TransactionUUID,
          StartDate,
          Enddate,
          paylaterstatus
        ).then(
          (data) => {
            const form = document.getElementById("confirmBookingButton");
            form.submit();
            dispatch(clearToCart());
          },
          (error) => {}
        );
        // }
      }
    }
  };

  let FreeAmountConfirmBooking = (e) => {
    e.preventDefault();
    let CheckError = false;
    let CheckErrorEmail = false;
    let CheckErrorMobile = false;

    let GuestN = [...Guest];

    for (var i = 0; i < GuestN.length; i++) {
      let firstregMatch = /^[a-zA-Z ]*$/.test(GuestN[i].FirstName);
      if (GuestN[i].FirstName.length >= 1 && firstregMatch) {
        CheckError = true;
        GuestN[i]["FirstNameError"] = false;
      } else {
        CheckError = false;
        GuestN[i]["FirstNameError"] = true;
      }
      let lastregMatch = /^[a-zA-Z ]*$/.test(GuestN[i].LastName);
      if (GuestN[i].LastName.length >= 1 && lastregMatch) {
        CheckError = true;
        GuestN[i]["LastNameError"] = false;
      } else {
        CheckError = false;
        GuestN[i]["LastNameError"] = true;
      }
    }

    setGuest(GuestN);

    const email = validEmailRegex.test(EmailId);
    if (email == true) {
      setEmailError(false);
      CheckErrorEmail = true;
    } else {
      CheckErrorEmail = false;
      setEmailError(true);
    }

    let mobileregMatch = /^[0-9]*$/.test(MobileNumber);
    if (MobileNumber.length > 5 && MobileNumber.length < 15 && mobileregMatch) {
      CheckErrorMobile = true;
      setMobileError(false);
    } else {
      CheckErrorMobile = false;
      setMobileError(true);
    }

    if (
      CheckError == true &&
      CheckErrorEmail == true &&
      CheckErrorMobile == true
    ) {
      let text =
        "Please confirm your details and amount of purchase before proceeding forward.";
      if (window.confirm(text) == true) {
        // text = "You pressed OK!";

        setDisablePayNowButton(true);
        setRedirect(true);
        let customerArr = localStorage.getItem("userDetails");

        let CustomArr = JSON.parse(customerArr);

        let customer_id = CustomArr?.uid;

        const TotalPrice = selectedData.reduce(
          (amount, item) => parseFloat(item.price) + amount,
          0
        );

        const TaxandFee = 0;
        let TotalPriceInclude = TaxandFee + TotalPrice;
        let CommissionPrice = 0;
        let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
        let paylaterstatus = 0;
        cartConfirmBookingAgentZeroAmount(
          TourDetails,
          Guest,
          GuestCount,
          EmailId,
          MobileNumber,
          MobileCode,
          customer_id,
          FinalPrice,
          CommissionPrice,
          TransactionUUID,
          StartDate,
          Enddate,
          paylaterstatus
        ).then(
          (data) => {
            const url = "/PlanTrips";
            window.location.replace(url);
            dispatch(clearToCart());
          },
          (error) => {}
        );
      }
    }
  };

  let renderDropdownMenu = (mainindex) => {
    return (
      <>
        {Guest.map((val, idx) => {
          if (val.mainID == mainindex) {
            return (
              <div className="paymakeFlex" key={idx}>
                <div className="guestDtls__col width70 appendRight10">
                  <p className="font11 capText appendBottom10">Title</p>
                  <div className="frmSelectCont">
                    <select
                      id="title"
                      value={Guest[idx].title}
                      className="frmSelect"
                      onChange={(e) => {
                        OnChangeTitle(e, idx);
                      }}
                    >
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                    </select>
                  </div>
                </div>
                <div className="paymakeFlex column flexOne">
                  <div className="paymakeFlex">
                    <div className="guestDtls__col width247 appendRight10">
                      <div className="textFieldCol ">
                        <p className="font11 appendBottom10 guestDtlsTextLbl">
                          <span className="capText">
                            FULL NAME AS PER PASSPORT
                          </span>
                        </p>
                        <input
                          type="text"
                          id="fName"
                          name="fName"
                          className={`frmTextInput ${
                            Guest[idx].FirstNameError ? "Err" : ""
                          }`}
                          value={Guest[idx].FirstName}
                          //onChange={(e) => OnChangeFirstName(e, idx)}
                          onChange={(e) => OnChangeFirstName(e, idx)}
                          placeholder="First Name"
                        />
                        {Guest[idx].FirstNameError && (
                          <p className="error">
                            {" "}
                            Please enter your First Name in Alphabet
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="guestDtls__col width247">
                      <div className="textFieldCol ">
                        <p className="font11 appendBottom10 guestDtlsTextLbl">
                          <span className="capText"></span>
                        </p>
                        <input
                          type="text"
                          id="lName"
                          name="lName"
                          className={`frmTextInput ${
                            Guest[idx].LastNameError ? "Err" : ""
                          }`}
                          value={Guest[idx].LastName}
                          onChange={(e) => OnChangeLastName(e, idx)}
                          placeholder="Last Name"
                        />

                        {Guest[idx].LastNameError && (
                          <p className="error">
                            {" "}
                            Please enter Last Name in Alphabet
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="guestDtls__col width71 appendRight11">
                      <p className="font11 capText appendBottom10">Age</p>
                      <div className="frmSelectCont">
                        <select
                          id="age"
                          value={Guest[idx].age}
                          className="frmSelect"
                          onChange={(e) => {
                            OnChangeAge(e, idx);
                          }}
                        >
                          {returnInputs()}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </>
    );
  };

  let HotelToggleHandler = () => {
    if (drop.class === "HotelInfo") {
      toggledrop({
        ...drop,
        class: "HotelInfoShort",
      });
    } else {
      toggledrop({
        ...drop,
        class: "HotelInfo",
      });
    }
  };

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      const GuesttravellerCount = JSON.parse(item.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Children&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.infantCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Infant,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.youthCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Youth,&nbsp;
                </>
              )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.seniorCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Senior,&nbsp;
                </>
              )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.groupCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Travelers,&nbsp;
                </>
              )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.adultCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Adults,&nbsp;
              </>
            )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.childCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Childs,&nbsp;
              </>
            )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
              <>
                <span class="latoBlack">
                  {GuesttravellerCount.reduce(
                    (a, v) => a + v.roomCounter * 1,
                    0
                  )}
                </span>
                &nbsp;Room,&nbsp;
              </>
            )}
          </>
        );
      }
    }
  };

  const finalPriceCybersouce = () => {
    const TotalPrice = selectedData.reduce(
      (amount, item) => parseFloat(item.price) + amount,
      0
    );

    const TaxandFee = 0;
    let TotalPriceInclude = TaxandFee + TotalPrice;
    let CommissionPrice = 0;
    let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
    return <input type="hidden" name="amount" value={FinalPrice.toFixed(2)} />;
  };

  const displayPayment = () => {
    const TotalPrice = selectedData.reduce(
      (amount, item) => parseFloat(item.totalamountincluded) + amount,
      0
    );

    const TotalPriceAll = selectedData.reduce(
      (amount, item) => parseFloat(item.totalAmount) + amount,
      0
    );
    // const OfferPrice = selectedData.reduce(
    //   (amount, item) => parseFloat(item.percentageAm) + amount,
    //   0
    // );

    const TaxandFee = 0;
    let TotalPriceInclude = TaxandFee + TotalPrice;
    // let CommissionPrice = 0;
    let FinalPrice = parseFloat(TotalPriceInclude);
    let OfferPrice = TotalPriceAll - TotalPriceInclude;
    // let JsonStatePDFAcco = {
    //   booking_amount: TotalPriceInclude,
    //   total_main_amount:TotalPriceAll,
    //    offer_discount: OfferPrice,
    //   // commission_price:CommissionPrice,
    //   numberof_night: 2,
    //   agentdetails: customerDetails?.agent,
    //   child: selectedData,
    // };
    // const propertypdf = JSON.stringify(
    //   JsonStatePDFAcco
    // );
    return (
      <div class="pricing-details">
        <div className="price-breakup">
          <div className="price-header">
            <h4 className="font16 latoBlack blackText">Price Breakup</h4>
          </div>
          <div className="total-amount">
            <div>
              <p>Base Price</p>
            </div>
            <div>
              <p
                className="latoBlack font16 blackText appendBottom5"
                id="hlistpg_hotel_shown_price"
              >
                <span>€</span>
                {TotalPrice.toFixed(2)}
              </p>
            </div>
          </div>
          {/* <div className="taxes">
              <h6 style={{ color: "black" }}>
                TAX & FEES
              </h6>
              <h6 style={{ color: "black" }}> <span>€</span> {TaxandFee.toFixed(2)}</h6>
            </div> */}
          {/* <div className="taxes">
            <h6 style={{ color: "black" }}>
              Less Agent Discount({Commission}%)
            </h6>
            <h6 style={{ color: "black" }}>
              <span>€</span>
              {CommissionPrice.toFixed(2)}{" "}
            </h6>
          </div> */}
          <div className="total-amount">
            <h6 style={{ color: "black" }}>Total Amount to be paid</h6>
            <h6 style={{ color: "red" }}>
              <FontAwesomeIcon
                icon={faEuroSign}
                style={{ fontSize: "14px", marginRight: "5px" }}
              ></FontAwesomeIcon>
              {FinalPrice.toFixed(2)}
            </h6>
          </div>
          <div className="total-amount">
            {/* {
          <PDFDownloadLink
            document={
              <InvoiceAgent
              invoice={
                propertypdf
              }
              />
            }
            fileName="Quotation.pdf"
            style={{
              fontSize:
                "12px",
              color:
                "#ff0000",
              fontWeight:
                "200",
            }}
          >
            {({
              blob,
              url,
              loading,
              error,
            }) =>
              loading
                ? "Loading document..."
                : "Download Quotation"
            }
          </PDFDownloadLink>
        } */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />
      <div className="sticky-scroll topSection appendBottom40">
        <div className="review" style={{ height: "65px" }}>
          <div className="landingContainer">
            <h4>Review Your Booking</h4>
          </div>
        </div>

        <div className="Details">
          <div className="landingContainer_details">
            <div className="subDetails">
              <form>
                {isPackageCart && (
                  <div
                    className="GuestInfo"
                    style={{ marginTop: 0 }}
                    key={"package"}
                  >
                    <div className="upper-Scroll">
                      <h6 style={{ color: "black" }}>Package</h6>
                    </div>
                    <div class="Container-Tile NewCartDetails">
                      <div class="Image-Section me-3">
                        <span
                          class=" lazy-load-image-background  lazy-load-image-loaded"
                          style={{
                            display: "inlineBlock",
                            marginRight: 10,
                          }}
                        >
                          <img
                            src={packageBasicDetails?.package_image}
                            class="gallery__img"
                          />
                        </span>
                      </div>

                      <div class="Text-Section">
                        <div class="Text-Contents">
                          <div class="Text-Ratings">
                            <p class="txtHeading latoBlack font18 blackText">
                              <span>{packageBasicDetails?.package_name}</span>
                            </p>
                          </div>
                          <div className="Small-Text">
                            <p
                              style={{
                                fontSize: "12px",
                                color: "#000",
                                marginTop: 8,
                                textAlign: "justify",
                                marginRight: 15,
                              }}
                            >
                              {ReactHtmlParser(
                                `${packageBasicDetails?.package_description.substring(
                                  0,
                                  250
                                )}...`
                              )}
                            </p>
                          </div>
                        </div>
                        <div class="Text-Contents">
                          <div class="Small-Text">
                            <div
                              class="padding20 makeFlex column"
                              style={{ marginTop: " 0px" }}
                            >
                              <p
                                class="latoBlack font16 blackText appendBottom5"
                                id="hlistpg_hotel_shown_price"
                              >
                                {constant.amountWithCurrency(
                                  customerPackageAfterDiscountAmount
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="chkCont" style={{ marginTop: "-21px" }}>
                      <div class="chkCont__col">
                        <div class="paymakeFlex column">
                          <span class="font10 grayText appendBottom3">
                            CHECK IN
                          </span>
                          <span class="latoBlack font16 blackText appendBottom3">
                            {displayDateFormat(
                              packageBasicDetails?.package_start_date
                            )}
                          </span>
                        </div>
                        <div class="chkCont__night">
                          <span>
                            {packageBasicDetails?.package_night} Nights
                          </span>
                        </div>
                        <div class="paymakeFlex column">
                          <span class="font10 grayText appendBottom3">
                            CHECK OUT
                          </span>
                          <span class="latoBlack font16 blackText appendBottom3">
                            {displayDateFormat(
                              packageBasicDetails?.package_end_date
                            )}
                          </span>
                        </div>
                      </div>
                      <div class="chkCont__col">
                        <p
                          class="font16 blackText"
                          style={{ fontSize: "12px" }}
                        >
                          {
                            packageBasicDetails?.package_guestCombination_sentence
                          }
                        </p>
                      </div>
                    </div>
                    <div class="form-guest">
                      {renderDropdownMenu(0)}
                      <div class="guestDtls__add"></div>
                    </div>
                  </div>
                )}
                <div>
                  {selectedData.length > 0 &&
                    Object.entries(
                      selectedData.filter(
                        (x) => !x.hasOwnProperty("package_id")
                      )
                    ).map((itemdata, j) => {
                      if (itemdata[1].profileactivity != "Accommodations") {
                        return (
                          <div
                            className="GuestInfo"
                            style={{ marginTop: 0 }}
                            key={j}
                          >
                            <div className="upper-Scroll">
                              <h6 style={{ color: "black" }}>
                                {itemdata[1].profileactivity}
                              </h6>
                            </div>
                            <div class="Container-Tile NewCartDetails">
                              <div class="Image-Section me-3">
                                <span
                                  class=" lazy-load-image-background  lazy-load-image-loaded"
                                  style={{
                                    display: "inlineBlock",
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    src={itemdata[1].tourImage}
                                    class="gallery__img"
                                  />
                                </span>
                              </div>

                              <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Text-Ratings">
                                    <p class="txtHeading latoBlack font18 blackText">
                                      <span>{itemdata[1].tourName}</span>
                                    </p>
                                  </div>
                                  <div className="Small-Text">
                                    {/* <p className="address" style={{ color: '#65cbf3' }}>
                                          {itemdata[1].tourLocation}
                                    </p> */}
                                    <p
                                      className="address"
                                      style={{ color: "#65cbf3" }}
                                    >
                                      {itemdata[1]?.pickuptransfer
                                        ? `${itemdata[1]?.pickuptransfer} to ${itemdata[1]?.droptransfer}`
                                        : `${itemdata[1].tourLocation}`}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                        marginTop: 8,
                                        textAlign: "justify",
                                        marginRight: 15,
                                      }}
                                    >
                                      {itemdata[1].overview != "undefined" &&
                                        ReactHtmlParser(
                                          `${itemdata[1].overview.substring(
                                            0,
                                            250
                                          )}...`
                                        )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {!itemdata[1].hasOwnProperty("package_id") && (
                                <div class="Text-Section">
                                  <div class="Text-Contents">
                                    <div class="Small-Text">
                                      <div
                                        class="padding20 makeFlex column"
                                        style={{ marginTop: " 0px" }}
                                      >
                                        <p
                                          class="latoBlack font16 blackText appendBottom5"
                                          id="hlistpg_hotel_shown_price"
                                        >
                                          <span>€</span>
                                          {parseFloat(
                                            itemdata[1].price
                                          ).toFixed(2)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div class="chkCont" style={{ marginTop: "-21px" }}>
                              <div class="chkCont__col">
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    DATE
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].dateselected).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                </div>
                                <div class="chkCont__night">
                                  <span></span>
                                </div>
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    Time
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {" "}
                                    {itemdata[1].time == "" ? (
                                      <> Coordinated Times</>
                                    ) : (
                                      <>{itemdata[1].time}</>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div class="chkCont__col">
                                <p
                                  class="font16 blackText"
                                  style={{ fontSize: "12px" }}
                                >
                                  {getTotalNumber(itemdata[1])}
                                </p>
                              </div>
                            </div>
                            {itemdata[1].OfferName != "" &&
                              itemdata[1].OfferName?.offerName && (
                                <div
                                  class="title__placeHolder font12 pc__bottomBox"
                                  style={{ marginTop: 0 }}
                                >
                                  <div class="persuasion ">
                                    <div class="persuasion__item pc__cashbackDeal">
                                      <span class="sprite infoIconGreen"></span>
                                      <span>
                                        {itemdata[1].OfferName?.offerName}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div class="form-guest">
                              {renderDropdownMenu(j)}
                              <div class="guestDtls__add"></div>
                              {j == 0 && (
                                <>
                                  {" "}
                                  <div class="form-check">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                      onClick={({ target: { value } }) =>
                                        onChangeSame(value)
                                      }
                                    />
                                    <label
                                      class="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Same Name Copy With Details
                                    </label>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      } else {
                        let date1 = new Date(itemdata[1].startDate);
                        let date2 = new Date(itemdata[1].endDate);

                        let timeDiff = Math.abs(
                          date1.getTime() - date2.getTime()
                        );
                        let numberOfNights = Math.ceil(
                          timeDiff / (1000 * 3600 * 24)
                        );
                        return (
                          <div
                            className="GuestInfo"
                            style={{ marginTop: 0 }}
                            key={j}
                          >
                            <div className="upper-Scroll">
                              <h6 style={{ color: "black" }}>
                                {itemdata[1].profileactivity}
                              </h6>
                            </div>
                            <div class="Container-Tile NewCartDetails">
                              <div class="Image-Section me-3">
                                <span
                                  class=" lazy-load-image-background  lazy-load-image-loaded"
                                  style={{
                                    display: "inlineBlock",
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    src={itemdata[1].hotelimage}
                                    class="gallery__img"
                                  />
                                </span>
                              </div>

                              <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Text-Ratings">
                                    <p class="txtHeading latoBlack font18 blackText">
                                      <span>{itemdata[1].propertyName}</span>
                                    </p>
                                  </div>
                                  <div className="Small-Text">
                                    <p
                                      className="address"
                                      style={{ color: "#65cbf3" }}
                                    >
                                      {itemdata[1].propertylocation}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                        marginTop: 8,
                                        textAlign: "justify",
                                        marginRight: 15,
                                      }}
                                    >
                                      {itemdata[1].property_source == 1 ? (
                                        <>
                                          {ReactHtmlParser(
                                            `${itemdata[1].propertydescription.description.substring(
                                              0,
                                              250
                                            )}...`
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {ReactHtmlParser(
                                            `${itemdata[1].propertydescription.substring(
                                              0,
                                              250
                                            )}...`
                                          )}
                                        </>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {!itemdata[1].hasOwnProperty("package_id") && (
                                <div class="Text-Section">
                                  <div class="Text-Contents">
                                    <div class="Small-Text">
                                      <div
                                        class="padding20 makeFlex column"
                                        style={{ marginTop: " 0px" }}
                                      >
                                        <p
                                          class="latoBlack font16 blackText appendBottom5"
                                          id="hlistpg_hotel_shown_price"
                                        >
                                          <span>€</span>
                                          {parseFloat(
                                            itemdata[1].price
                                          ).toFixed(2)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div class="chkCont" style={{ marginTop: "-21px" }}>
                              <div class="chkCont__col">
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    CHECK IN
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].startDate).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                  <span class="font10 grayText 444">
                                    {moment(itemdata[1].startDate).format(
                                      "dddd"
                                    )}
                                    , {itemdata[1].checkin}
                                  </span>
                                </div>
                                <div class="chkCont__night">
                                  <span>{numberOfNights} Nights</span>
                                </div>
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    CHECK OUT
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].endDate).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                  <span class="font10 grayText">
                                    {" "}
                                    {moment(itemdata[1].endDate).format("dddd")}
                                    , , {itemdata[1].checkout}
                                  </span>
                                </div>
                              </div>
                              <div class="chkCont__col">
                                <p
                                  class="font16 blackText"
                                  style={{ fontSize: "12px" }}
                                >
                                  {getTotalNumber(itemdata[1])}
                                </p>
                              </div>
                            </div>
                            <div class="rmDtl appendBottom15">
                              <div class="roomDtlCard">
                                <div class="roomDtlCard__head">
                                  <ul class="impInfoCard__list">
                                    {itemdata[1].junifer != null ? (
                                      <>
                                        {itemdata[1].junifer.HotelRooms
                                          .HotelRoom.length > 0 ? (
                                          <>
                                            {" "}
                                            {itemdata[1].junifer.HotelRooms.HotelRoom.map(
                                              (roomname, index) => (
                                                <>
                                                  <li>
                                                    <p
                                                      class="latoBlack font14 blackText"
                                                      // style={{
                                                      //   lineHeight: "25px",
                                                      // }}
                                                    >
                                                      {
                                                        roomname.attributes
                                                          .Units
                                                      }{" "}
                                                      X {roomname.Name} (
                                                      {
                                                        itemdata[1].junifer
                                                          .Board
                                                      }
                                                      )
                                                    </p>
                                                  </li>
                                                </>
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <li>
                                              <p
                                                class="latoBlack font14 blackText"
                                                // style={{ lineHeight: "25px" }}
                                              >
                                                {
                                                  itemdata[1].junifer.HotelRooms
                                                    .HotelRoom.attributes.Units
                                                }{" "}
                                                X{" "}
                                                {
                                                  itemdata[1].junifer.HotelRooms
                                                    .HotelRoom.Name
                                                }{" "}
                                                ({itemdata[1].junifer.Board})
                                              </p>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {itemdata[1].typedata == "multiple" ? (
                                          <>
                                            {itemdata[1].cartvalue.map(
                                              (cartitem, indexcart) => (
                                                <>
                                                  <li>
                                                    <p
                                                      class="latoBlack font14 blackText"
                                                      // style={{
                                                      //   lineHeight: "25px",
                                                      // }}
                                                    >
                                                      {cartitem.roomCounter} X{" "}
                                                      {cartitem.name}
                                                    </p>
                                                  </li>
                                                </>
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <li>
                                              <p
                                                class="latoBlack font14 blackText"
                                                // style={{ lineHeight: "25px" }}
                                              >
                                                1 X {itemdata[1].roomname}
                                              </p>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            {itemdata[1].junifer != null &&
                            itemdata[1].junifer.HotelOfferName != "" ? (
                              <div class="title__placeHolder font12 pc__bottomBox">
                                <div class="persuasion ">
                                  <div class="persuasion__item pc__cashbackDeal">
                                    <span class="sprite infoIconGreen"></span>
                                    <span>
                                      {itemdata[1].junifer.HotelOfferName}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                {itemdata[1].OfferName != "" &&
                                itemdata[1].OfferName != "multipleOffer" ? (
                                  <div class="title__placeHolder font12 pc__bottomBox">
                                    <div class="persuasion ">
                                      <div class="persuasion__item pc__cashbackDeal">
                                        <span class="sprite infoIconGreen"></span>
                                        <span>
                                          {itemdata[1].OfferName[0].offerName}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    {" "}
                                    {itemdata[1].OfferName == "multipleOffer" &&
                                      itemdata[1].cartvalue.map(
                                        (cartitem, indexcart) => {
                                          if (cartitem.OfferData) {
                                            return (
                                              <>
                                                <div class="title__placeHolder font12 pc__bottomBox">
                                                  <div class="persuasion ">
                                                    <div class="persuasion__item pc__cashbackDeal">
                                                      <span class="sprite infoIconGreen"></span>
                                                      <span>
                                                        {
                                                          cartitem.OfferData[0]
                                                            .offerName
                                                        }
                                                        {itemdata[1].cartvalue
                                                          .length -
                                                          1 ===
                                                        indexcart
                                                          ? ""
                                                          : ","}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          }
                                        }
                                      )}
                                  </>
                                )}
                              </>
                            )}
                            <div class="form-guest">
                              {renderDropdownMenu(j)}
                              <div class="guestDtls__add"></div>
                              {j == 0 && (
                                <>
                                  {" "}
                                  <div class="form-check">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                      onClick={({ target: { value } }) =>
                                        onChangeSame(value)
                                      }
                                    />
                                    <label
                                      class="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Same Name Copy With Details
                                    </label>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>

                {selectedData.length > 0 ? (
                  <>
                    <div className="GuestInfo" style={{ marginTop: 0 }}>
                      <div className="upper-Scroll">
                        <h6 style={{ color: "black" }}></h6>
                      </div>

                      <div class="form-guest">
                        <div className="guestDtls__row">
                          <div className="paymakeFlex">
                            <div className="guestDtls__col width327 appendRight10">
                              <div className="textFieldCol ">
                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                  <span className="capText">Email Address</span>
                                  <span className="grayText appendLeft3">
                                    (Any Booking voucher will be sent to this
                                    email ID)
                                  </span>
                                </p>
                                <input
                                  type="text"
                                  id="email"
                                  name="email"
                                  className={`frmTextInput ${
                                    EmailError ? "Err" : ""
                                  }`}
                                  value={EmailId}
                                  onChange={(e) => {
                                    OnChangeEmailId(e);
                                  }}
                                  placeholder="Email ID"
                                />
                                {EmailError && (
                                  <p className="error">
                                    {" "}
                                    Please enter a valid Email ID!
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="guestDtls__col width327">
                              <p className="font11 capText appendBottom10">
                                Mobile Number
                              </p>
                              <div className="paymakeFlex textLtr">
                                <div className="guestDtls__contact">
                                  <label
                                    for="mCode"
                                    className=" frmSelectCont__contact"
                                  >
                                    <select
                                      id="mCode"
                                      className="frmSelect frmSelectContact"
                                      value={MobileCode}
                                      onChange={OnChangeMobileCode}
                                    >
                                      {DialCode.map((item, key) => (
                                        <option value={item.dial_code}>
                                          {item.name}&nbsp;({item.dial_code})
                                        </option>
                                      ))}
                                    </select>
                                  </label>
                                  <span className="selectedCode">
                                    {MobileCode == ""
                                      ? country_code
                                      : MobileCode}
                                  </span>
                                </div>
                                <div className="flexOne">
                                  <div className="textFieldCol ">
                                    <input
                                      type="text"
                                      id="mNo"
                                      name="mNo"
                                      className={`frmTextInput noLeftBorder ${
                                        MobileError ? "Err" : ""
                                      }`}
                                      placeholder="Mobile Number"
                                      value={MobileNumber}
                                      onChange={(e) => {
                                        OnChangeMobileNumber(e);
                                      }}
                                    />
                                    {MobileError && (
                                      <p className="error">
                                        {" "}
                                        Please enter a valid number!
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="guestDtls__add"></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </form>

              <form
                id="confirmBookingButton"
                action={CyberSource}
                method="post"
              >
                {selectedData.length > 0 ? (
                  <>
                    <input
                      type="hidden"
                      name="bill_to_forename"
                      value={Guest[0].FirstName}
                    />
                    <input
                      type="hidden"
                      name="bill_to_surname"
                      value={Guest[0].LastName}
                    />
                    <input type="hidden" name="currency" value="EUR" />
                    {finalPriceCybersouce()}

                    <input type="hidden" name="bill_to_email" value={EmailId} />
                    <input
                      type="hidden"
                      name="transaction_uuid"
                      value={TransactionUUID}
                    />

                    {selectedData.reduce(
                      (amount, item) =>
                        parseFloat(item.totalamountincluded) + amount,
                      0
                    ) == 0 ? (
                      <div style={{ padding: "10px 0px" }}>
                        <p style={{ padding: "10px 0px" }}>
                          By proceeding, I agree to Holidays Seychelles User
                          Agreement, Terms of Service and Cancellation & Hotel
                          Booking Policies
                        </p>
                        <button
                          className="pay"
                          onClick={FreeAmountConfirmBooking}
                          disabled={DisablePayNowButton}
                        >
                          Booking Now
                        </button>
                      </div>
                    ) : (
                      <div style={{ padding: "10px 0px" }}>
                        <p style={{ padding: "10px 0px" }}>
                          By proceeding, I agree to Holidays Seychelles User
                          Agreement, Terms of Service and Cancellation & Hotel
                          Booking Policies
                        </p>
                        <button
                          className="pay"
                          onClick={
                            customerDetails == "abc"
                              ? loginPage
                              : ConfirmBooking
                          }
                          disabled={DisablePayNowButton}
                        >
                          Pay Now
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </form>

              {selectedData.length <= 0 ? (
                <>
                  {" "}
                  <div class="card"></div>
                </>
              ) : (
                <></>
              )}
            </div>

            {selectedData.length > 0 ? <>{displayPayment()}</> : <></>}
          </div>
        </div>
      </div>
      <LoginComponent
        open={isLoginOpen}
        onClose={onCloseLogin}
        onOpen={onOpenLogin}
      />
    </div>
  );
}

export default PaymentCartDetails;
